module.exports = __webpack_public_path__ + "static/media/emojiSmiling.86aef839.svg";